<script context="module">
	import { img, a } from '$internal/mdsvex/components';
	export { img, a };
</script>

<script>
	import Breadcrumbs from '$internal/components/breadcrumbs/Breadcrumbs.svelte';
	import Time from '$internal/components/time/Time.svelte';
	import ReadingProgressBar from '$internal/components/progress/ReadingProgressBar.svelte';

	/**
	 * @type {string}
	 */
	export let title;

	/**
	 * @type {string}
	 */
	export let description;

	/**
	 * @type {boolean | undefined | null}
	 */
	export let draft = null;

	/**
	 * @type {string | undefined | null}
	 */
	export let created_at = null;

	/**
	 * @type {string | undefined | null}
	 */
	export let updated_at = null;

	/**
	 * @type {{ breadcrumbs: boolean | undefined, progress: boolean | undefined } | undefined}
	 */
	export let features = undefined
</script>

{#if features?.progress}
	<ReadingProgressBar heightPx={3} />
{/if}

<main class="prose md:prose-xl max-w-screen-lg mx-auto my-20 px-8">
	{#if features?.breadcrumbs}
		<Breadcrumbs class="sticky top-[3px] mb-4 bg-base-100" />
	{/if}

	<h1>{title}</h1>
	<p>{description}</p>
	{#if draft}
		<output class="badge badge-accent">This page is a draft!</output>
	{/if}

	{#if created_at}
		<p>Created: <Time date={created_at} /></p>
	{/if}
	{#if updated_at}
		<p>Last update: <Time date={updated_at} /></p>
	{/if}

	<slot />
</main>
